export const getTextDecoration = (
  textUnderline: boolean,
  textLineThrough: boolean
) => {
  return textUnderline || textLineThrough
    ? `${textUnderline ? 'underline' : ''} ${
      textLineThrough ? 'line-through' : ''
    }`
    : 'none';
};

export const getButtonPadding = (buttonSize: string) => {
  if (buttonSize === 'large') {
    return '0 30px';
  }

  if (buttonSize === 'medium') {
    return '0 24px';
  }

  return '0 20px';
};
